import React from "react";
import { useTranslation } from "react-i18next";
import { CourseModel } from "@common/domain/models/Course";
import { translate } from '@translations/Translater';
import { WFImg } from "@components/index";
import { WFMarkdown } from "@components/index";
import Text, { FontFamilyVariant, TextType } from '@components/Text';
import { courseDetailsMessages } from "@containers/CourseDetailsContainer/messages";
import { WatchIcon } from "@assets/index";
import Navigator from "@navigator/index";
import { NavigationUrl, URLs } from '@navigator/NavigationUrl';
import "./styles.less";
import { getLoggedInUserId } from "@utils/UserUtils";

interface Iprops {
    courseDetails: CourseModel;
}

const PopularClassCard = (props: Iprops) => {
    const { courseDetails } = props;
    const { t } = useTranslation();
    const navigateToCourseDetail = () => {
        if (getLoggedInUserId()) {
            Navigator.push(NavigationUrl.generate(URLs.courseDetails, { courseId: courseDetails?.getCourseId() }));
        } else {
            Navigator.push(NavigationUrl.generate(URLs.guestCourseDetail, { courseId: courseDetails?.getCourseRootId() }));
        }
    };

    if (Object?.keys(courseDetails)?.length === 0) {
        return null
    };
    
    return (
        <div className="popular_class_card_container" onClick={navigateToCourseDetail}>
            <WFImg src={courseDetails?.getThumbnail()} className="popular_course_img" />
            <div className="course_details">
                {/* <Text
                    className="course_category_name"
                    textType={TextType.paragraph1}
                    fontFamilyVariant={FontFamilyVariant.medium}
                    text={"Category"}
                /> */}
                <div className="duration_container">
                    <WFImg src={WatchIcon} className="duration_icon" />
                    <Text
                        className="course_duration_text"
                        textType={TextType.paragraph1}
                        fontFamilyVariant={FontFamilyVariant.medium}
                        text={`${courseDetails?.getDuration()} ${translate(t, courseDetailsMessages.hours)}`}
                    />
                </div>
            </div>
            <Text
                className="course_name"
                textType={TextType.paragraph1}
                fontFamilyVariant={FontFamilyVariant.bold}
                text={<WFMarkdown>{courseDetails?.getCourseName()}</WFMarkdown>}
            />

        </div>
    )
}

export default PopularClassCard;
